module.exports = __webpack_public_path__ + "static/media/chair-sun.86cdff81.svg";